module.exports = __webpack_public_path__ + "img/magento-version-switching_medium@2x.f3e988eb.webp";